module.exports = __webpack_public_path__ + "img/delete_fd.3cf587df.svg";